export default "__VITE_ASSET__DV37pqI1__"